import { createGuideLink, ArticlePath, TextKey } from '@mews-commander/enums';
import { SmallContainer } from '@mews-commander/ui';
import { Target } from '@mews/enums';
import { LocalizedText } from '@mews/framework';
import { Stack, EmptyState, Typography, Link } from '@optimus-web/core';
import { AssignPropertiesContainer } from './AssignPropertiesContainer';

export const PropertiesTabEmptyState = ({ rateGroupId }: { rateGroupId: string }) => (
    <Stack alignment="center">
        <SmallContainer>
            <EmptyState
                primaryText={
                    <Typography textStyle="bodyLargeStrong" as="div">
                        <LocalizedText textKey={TextKey.RateGroupPropertiesEmptyStateTitle} />
                    </Typography>
                }
                secondaryText={
                    <Typography textStyle="bodyMedium" align="center" as="div">
                        <LocalizedText textKey={TextKey.RateGroupPropertiesEmptyStateDescription} />
                    </Typography>
                }
                action={
                    <>
                        <AssignPropertiesContainer buttonTextKey={TextKey.AddProperties} rateGroupId={rateGroupId} />
                        <Link target={Target.Blank} href={createGuideLink(ArticlePath.PortfolioRateGroupCreation)}>
                            <LocalizedText textKey={TextKey.LearnMoreAboutCentralRateGroups} />
                        </Link>
                    </>
                }
            />
        </SmallContainer>
    </Stack>
);
